import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, unref as _unref, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "vt-page" }
const _hoisted_2 = { class: "vt-shell" }
const _hoisted_3 = { class: "vt-card vt-stack" }
const _hoisted_4 = { class: "vt-route" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "vt-route__line" }
const _hoisted_7 = {
  class: "vt-icon",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "1.7",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}
const _hoisted_8 = ["d"]
const _hoisted_9 = { class: "vt-amount" }
const _hoisted_10 = {
  key: 0,
  class: "vt-amount__converted"
}
const _hoisted_11 = { class: "vt-warning" }
const _hoisted_12 = {
  class: "vt-icon",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "1.7",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}
const _hoisted_13 = ["d"]
const _hoisted_14 = { class: "vt-card vt-stack" }
const _hoisted_15 = { class: "vt-row__icon" }
const _hoisted_16 = {
  class: "vt-icon",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "1.7",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}
const _hoisted_17 = ["d"]
const _hoisted_18 = { class: "vt-row__body" }
const _hoisted_19 = { class: "vt-label" }
const _hoisted_20 = { class: "vt-value" }
const _hoisted_21 = ["aria-label", "onClick"]
const _hoisted_22 = {
  class: "vt-icon",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "1.7",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}
const _hoisted_23 = ["d"]
const _hoisted_24 = { class: "vt-row" }
const _hoisted_25 = { class: "vt-row__body" }
const _hoisted_26 = { class: "vt-label" }
const _hoisted_27 = { class: "vt-value" }
const _hoisted_28 = { class: "vt-country" }
const _hoisted_29 = ["aria-label"]
const _hoisted_30 = {
  class: "vt-icon",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "1.7",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}
const _hoisted_31 = ["d"]
const _hoisted_32 = ["disabled"]
const _hoisted_33 = ["src"]
const _hoisted_34 = {
  key: 1,
  class: "vt-card vt-stack vt-center"
}
const _hoisted_35 = ["innerHTML"]
const _hoisted_36 = { class: "vt-card vt-stack" }
const _hoisted_37 = { class: "vt-timer" }
const _hoisted_38 = { class: "vt-progress" }
const _hoisted_39 = ["disabled"]
const _hoisted_40 = {
  class: "vt-icon",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "1.7",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}
const _hoisted_41 = ["d"]
const _hoisted_42 = {
  key: 1,
  class: "vt-card vt-state"
}
const _hoisted_43 = {
  key: 0,
  class: "vt-upload"
}
const _hoisted_44 = {
  key: 1,
  class: "vt-small"
}
const _hoisted_45 = { class: "vt-state__icon vt-state__icon--success" }
const _hoisted_46 = {
  class: "vt-icon",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "1.7",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}
const _hoisted_47 = ["d"]
const _hoisted_48 = { class: "vt-state__icon vt-state__icon--yellow" }
const _hoisted_49 = {
  class: "vt-icon",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "1.7",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}
const _hoisted_50 = ["d"]
const _hoisted_51 = { class: "vt-state__icon vt-state__icon--danger" }
const _hoisted_52 = {
  class: "vt-icon",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "1.7",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}
const _hoisted_53 = ["d"]
const _hoisted_54 = { class: "vt-row" }
const _hoisted_55 = { class: "vt-row__icon" }
const _hoisted_56 = {
  class: "vt-icon",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "1.7",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}
const _hoisted_57 = ["d"]
const _hoisted_58 = { class: "vt-row__body" }
const _hoisted_59 = { class: "vt-label" }
const _hoisted_60 = { class: "vt-value" }
const _hoisted_61 = ["aria-label"]
const _hoisted_62 = {
  class: "vt-icon",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "1.7",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}
const _hoisted_63 = ["d"]
const _hoisted_64 = ["href"]
const _hoisted_65 = ["aria-label"]
const _hoisted_66 = {
  class: "vt-icon",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "1.7",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}
const _hoisted_67 = ["d"]
const _hoisted_68 = { class: "vt-modal__title" }
const _hoisted_69 = {
  key: 0,
  class: "vt-stack"
}
const _hoisted_70 = { class: "vt-small vt-center" }
const _hoisted_71 = { class: "vt-slide" }
const _hoisted_72 = ["src", "alt"]
const _hoisted_73 = { class: "vt-buttons" }
const _hoisted_74 = {
  key: 1,
  class: "vt-stack"
}
const _hoisted_75 = { class: "vt-modal__text" }
const _hoisted_76 = { class: "vt-amount" }
const _hoisted_77 = { class: "vt-row__icon" }
const _hoisted_78 = {
  class: "vt-icon",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "1.7",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}
const _hoisted_79 = ["d"]
const _hoisted_80 = { class: "vt-row__body" }
const _hoisted_81 = { class: "vt-label" }
const _hoisted_82 = { class: "vt-value" }
const _hoisted_83 = ["aria-label", "onClick"]
const _hoisted_84 = {
  class: "vt-icon",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "1.7",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}
const _hoisted_85 = ["d"]
const _hoisted_86 = {
  key: 0,
  class: "vt-small vt-center"
}
const _hoisted_87 = {
  key: 1,
  class: "vt-error"
}
const _hoisted_88 = {
  key: 2,
  class: "vt-stack"
}
const _hoisted_89 = { class: "vt-warning" }
const _hoisted_90 = {
  class: "vt-icon",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "1.7",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}
const _hoisted_91 = ["d"]
const _hoisted_92 = { class: "vt-modal__text" }
const _hoisted_93 = { class: "vt-row__icon" }
const _hoisted_94 = {
  class: "vt-icon",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "1.7",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}
const _hoisted_95 = ["d"]
const _hoisted_96 = { class: "vt-row__body" }
const _hoisted_97 = { class: "vt-label" }
const _hoisted_98 = { class: "vt-value" }
const _hoisted_99 = {
  key: 0,
  class: "vt-stack"
}
const _hoisted_100 = {
  class: "vt-label",
  for: "vt-trx-input"
}
const _hoisted_101 = ["value", "placeholder"]
const _hoisted_102 = {
  key: 0,
  class: "vt-error"
}
const _hoisted_103 = ["disabled"]

import "@/assets/css/vasl-transfer.css"
import {computed, onMounted, onUnmounted, ref, watch} from "vue";
import {useI18n} from "vue-i18n";
import QRCode from "qrcode-svg";
import DealDTO from "@/models/DealDTO";
import InvoiceStateDTO from "@/models/InvoiceStateDTO";
import APIClient from "@/service/APIClient";
import copyTextToClipboard from "@/service/CopyHelper";
import {numberFormatter} from "@/service/NumberFormatter";
import {paymentMethodsHelper} from "@/service/PaymentMethodsHelper";
import {copy, openDeeplink, state as copyState} from "@/service/helper";
import {DealStatus} from "@/enum/DealStatus";
import {InvoiceStatus} from "@/enum/InvoiceStatus";

type VaslBank = 'psb' | 'gazprom'
type ModalName = 'instruction' | 'bank' | 'confirm'

const VASL_LOGO = '/img/instructions_psb_vasl/vasl-logo.png'
const INSTRUCTION_STEPS = 7
const BANK_REDIRECT_DELAY_MS = 7000


export default /*@__PURE__*/_defineComponent({
  __name: 'VaslTransferPage',
  props: {
    bank: {},
    confirmTransfer: { type: Function },
    cancelDeal: { type: Function },
    currentDeal: {},
    invoice: {},
    transactionId: {},
    transactionIdError: {}
  },
  emits: ["update:transactionId"],
  setup(__props: any, { emit: __emit }) {

const BANKS: Record<VaslBank, {method: string, labelKey: string, color: string}> = {
  psb: {method: 'promsvyaz', labelKey: 'vasl-transfer.bank-psb', color: '#2C2D84'},
  gazprom: {method: 'gazprombank', labelKey: 'vasl-transfer.bank-gazprom', color: '#476BF0'},
}

const icons: Record<string, string> = {
  chevron: 'M9 6l6 6-6 6',
  warning: 'M12 3L2 21h20z M12 9v5 M12 17v1',
  phone: 'M22 16v3a2 2 0 01-2 2A19 19 0 013 4a2 2 0 012-2h3l2 5-2 2a15 15 0 007 7l2-2z',
  user: 'M5 21v-3a7 7 0 0114 0v3 M12 3a4 4 0 100 8 4 4 0 000-8',
  card: 'M3 6h18v13H3z M3 10h18',
  copy: 'M9 9h11v11H9z M15 5V2H2v13h3',
  graduation: 'M2 9l10-5 10 5-10 5z M6 11v6c4 3 8 3 12 0v-6 M22 9v7',
  doubleCheck: 'M18 6L7 17l-5-5 M22 10l-7 7-2-2',
  check: 'M5 12l4 4L20 5',
  close: 'M6 6l12 12 M6 18L18 6',
  clock: 'M12 8v5l3 2 M4 4L2 6 M20 4l2 2',
  info: 'M12 8v1 M12 12v5',
}

const props = __props

const emit = __emit

const {t, te} = useI18n({useScope: 'global'})
const api = new APIClient()

const now = ref(Date.now())
const modal = ref<ModalName | null>(null)
const instructionStep = ref(1)
const bankDeadline = ref<number | null>(null)
const bankError = ref('')
const receiptUploaded = ref(false)
const isDesktop = ref(window.matchMedia('(min-width: 768px)').matches)
const desktopQuery = window.matchMedia('(min-width: 768px)')
let timer: number | null = null

const onDesktopChange = (e: MediaQueryListEvent) => {
  isDesktop.value = e.matches
}

onMounted(() => {
  timer = window.setInterval(() => {
    now.value = Date.now()
  }, 250)
  desktopQuery.addEventListener('change', onDesktopChange)
})

onUnmounted(() => {
  if (timer !== null) {
    clearInterval(timer)
  }
  desktopQuery.removeEventListener('change', onDesktopChange)
})

const bank = computed(() => BANKS[props.bank])
const bankLogo = computed(() => paymentMethodsHelper.getLogo(bank.value.method))

const isFinal = computed(() => [InvoiceStatus.PAID, InvoiceStatus.CANCELED, InvoiceStatus.EXPIRED].includes(props.invoice.status)
  || [DealStatus.COMPLETED, DealStatus.CANCELED].includes(props.currentDeal.status))

const phase = computed<'pay' | 'verify' | 'result'>(() => {
  if (isFinal.value) {
    return 'result'
  }
  return props.currentDeal.status === DealStatus.TRANSFER_WAITING ? 'pay' : 'verify'
})

const isPaid = computed(() => props.invoice.status === InvoiceStatus.PAID || props.currentDeal.status === DealStatus.COMPLETED)
const isExpired = computed(() => props.invoice.status === InvoiceStatus.EXPIRED)
const isDispute = computed(() => props.currentDeal.status === DealStatus.DISPUTE)
const canUploadReceipt = computed(() => props.currentDeal.status === DealStatus.TRANSFER_CONFIRMED
  && props.invoice.flowData?.options?.hideUploadReceipt !== true)
const returnUrl = computed(() => isPaid.value ? props.invoice.successUrl : props.invoice.cancelUrl)
const invoiceNumber = computed(() => props.invoice.internalId || props.invoice.id)

const deadline = computed(() => new Date(props.currentDeal.canceledAt).getTime())
const secondsLeft = computed(() => Math.max(0, Math.floor((deadline.value - now.value) / 1000)))
const canAct = computed(() => phase.value === 'pay' && secondsLeft.value > 0)

const timeLeft = computed(() => {
  const minutes = Math.floor(secondsLeft.value / 60)
  return `${String(minutes).padStart(2, '0')}:${String(secondsLeft.value % 60).padStart(2, '0')}`
})

const timePercent = computed(() => {
  const createdAt = new Date(props.currentDeal.createdAt).getTime()
  const total = deadline.value - createdAt
  if (total <= 0) {
    return 0
  }
  return Math.min(100, Math.max(0, (deadline.value - now.value) / total * 100))
})

const localSum = computed(() => {
  const sum = props.invoice.flowData?.receiveSum
  if (
    sum
    && sum.amount !== undefined
    && sum.amount !== null
    && sum.amount !== ''
    && typeof sum.currency === 'string'
    && sum.currency !== ''
  ) {
    return {amount: Number(sum.amount), currency: String(sum.currency)}
  }
  return null
})

const rubText = computed(() => numberFormatter.formatMoney(Number(props.invoice.sum.amount), props.invoice.sum.currency) ?? '')

const targetText = computed(() => localSum.value
  ? (numberFormatter.formatMoney(localSum.value.amount, localSum.value.currency) ?? rubText.value)
  : rubText.value)

const amountForCopy = computed(() => {
  const amount = localSum.value ? localSum.value.amount : Number(props.invoice.sum.amount)
  return Number.isInteger(amount) ? String(amount) : amount.toFixed(2).replace('.', ',')
})

const countryName = computed(() => te('countries.TJS') ? t('countries.TJS') : 'Таджикистан')

const rawRequisites = computed(() => String(props.currentDeal.requisites?.requisites ?? '').trim())

const phoneText = computed(() => {
  const match = rawRequisites.value.replace(/\D/g, '').match(/^(992)(\d{2})(\d{3})(\d{2})(\d{2})$/)
  return match ? `+${match[1]} ${match[2]} ${match[3]} ${match[4]} ${match[5]}` : rawRequisites.value
})

const holder = computed(() => String(props.currentDeal.requisites?.holder ?? '').trim())

const rows = computed(() => {
  const result = [
    {key: 'phone', icon: 'phone', label: t('vasl-transfer.field-phone'), value: phoneText.value, copy: rawRequisites.value},
    {key: 'holder', icon: 'user', label: t('vasl-transfer.field-recipient'), value: holder.value, copy: ''},
  ]
  if (localSum.value) {
    result.push({key: 'amount', icon: 'card', label: t('vasl-transfer.field-amount'), value: targetText.value, copy: amountForCopy.value})
  }
  return result.filter((row) => row.value !== '')
})

const confirmRows = computed(() => [
  {key: 'amount', icon: 'card', label: t('vasl-transfer.field-amount'), value: targetText.value},
  ...rows.value.filter((row) => row.key !== 'amount'),
])

const qrSvg = computed(() => new QRCode({
  content: window.location.href,
  join: true,
  container: 'svg-viewbox',
  padding: 0,
  color: '#000000',
  background: '#FFFFFF',
}).svg())

const modalTitle = computed(() => {
  if (modal.value === 'instruction') {
    return t('vasl-transfer.instruction')
  }
  return t(modal.value === 'bank' ? 'vasl-transfer.bank-modal-title' : 'vasl-transfer.confirm-title')
})

const bankSecondsLeft = computed(() => bankDeadline.value === null
  ? null
  : Math.max(0, Math.ceil((bankDeadline.value - now.value) / 1000)))

const openInstruction = () => {
  instructionStep.value = 1
  modal.value = 'instruction'
}

const nextInstructionStep = () => {
  if (instructionStep.value >= INSTRUCTION_STEPS) {
    closeModal()
    return
  }
  instructionStep.value++
}

const closeModal = () => {
  modal.value = null
  bankDeadline.value = null
}

const openBank = () => {
  bankDeadline.value = null
  const deeplinks = props.invoice.flowData?.deeplinks
  if (Array.isArray(deeplinks) && deeplinks.length > 0) {
    openDeeplink(deeplinks)
    return
  }
  bankError.value = t('vasl-transfer.bank-link-unavailable')
}

const onOpenBank = () => {
  if (!canAct.value) {
    return
  }
  bankError.value = ''
  copyTextToClipboard(null, amountForCopy.value)
  modal.value = 'bank'
  bankDeadline.value = Date.now() + BANK_REDIRECT_DELAY_MS
}

watch(now, (value) => {
  if (modal.value === 'bank' && bankDeadline.value !== null && value >= bankDeadline.value) {
    openBank()
  }
})

watch(phase, (value) => {
  if (value !== 'pay') {
    closeModal()
  }
})

const onTransactionIdInput = (e: Event) => {
  emit('update:transactionId', (e.target as HTMLInputElement).value)
}

const onReceiptSelected = async (e: Event) => {
  const file = (e.target as HTMLInputElement).files?.[0]
  if (!file) {
    return
  }
  await api.confirmTransfer(props.invoice.id, props.currentDeal.id, file)
  receiptUploaded.value = true
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (phase.value === 'pay')
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createElementVNode("section", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("span", null, [
                  _createElementVNode("img", {
                    class: "vt-logo",
                    src: bankLogo.value,
                    alt: ""
                  }, null, 8, _hoisted_5),
                  _createTextVNode(_toDisplayString(_ctx.$t(bank.value.labelKey)), 1)
                ]),
                _createElementVNode("span", _hoisted_6, [
                  (_openBlock(), _createElementBlock("svg", _hoisted_7, [
                    _createElementVNode("path", {
                      d: icons.chevron
                    }, null, 8, _hoisted_8)
                  ]))
                ]),
                _createElementVNode("span", null, [
                  _createTextVNode(_toDisplayString(_ctx.$t('vasl-transfer.receiver-bank')), 1),
                  _createElementVNode("img", {
                    class: "vt-logo",
                    src: VASL_LOGO,
                    alt: ""
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_9, [
                _createTextVNode(_toDisplayString(targetText.value) + " ", 1),
                (localSum.value)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_10, "= " + _toDisplayString(rubText.value), 1))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_11, [
                (_openBlock(), _createElementBlock("svg", _hoisted_12, [
                  _createElementVNode("path", {
                    d: icons.warning
                  }, null, 8, _hoisted_13)
                ])),
                _createElementVNode("span", null, [
                  _createTextVNode(_toDisplayString(_ctx.$t('vasl-transfer.pay-once')) + " ", 1),
                  _createElementVNode("strong", null, _toDisplayString(_ctx.$t('vasl-transfer.pay-once-strong', {amount: targetText.value})), 1)
                ])
              ])
            ]),
            _createElementVNode("section", _hoisted_14, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(rows.value, (row) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: row.key,
                  class: "vt-row"
                }, [
                  _createElementVNode("span", _hoisted_15, [
                    (_openBlock(), _createElementBlock("svg", _hoisted_16, [
                      _createElementVNode("path", {
                        d: icons[row.icon]
                      }, null, 8, _hoisted_17)
                    ]))
                  ]),
                  _createElementVNode("div", _hoisted_18, [
                    _createElementVNode("span", _hoisted_19, _toDisplayString(row.label), 1),
                    _createElementVNode("span", _hoisted_20, _toDisplayString(row.value), 1)
                  ]),
                  (row.copy)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        type: "button",
                        class: "vt-copy",
                        "aria-label": _ctx.$t('vasl-transfer.copy'),
                        onClick: _withModifiers(($event: any) => (_unref(copy)(null, row.copy)), ["prevent"])
                      }, [
                        (_openBlock(), _createElementBlock("svg", _hoisted_22, [
                          _createElementVNode("path", {
                            d: icons.copy
                          }, null, 8, _hoisted_23)
                        ]))
                      ], 8, _hoisted_21))
                    : _createCommentVNode("", true)
                ]))
              }), 128)),
              _cache[6] || (_cache[6] = _createElementVNode("div", { class: "vt-divider" }, null, -1)),
              _createElementVNode("div", _hoisted_24, [
                _createElementVNode("span", { class: "vt-row__icon" }, [
                  _createElementVNode("img", {
                    class: "vt-logo",
                    src: VASL_LOGO,
                    alt: ""
                  })
                ]),
                _createElementVNode("div", _hoisted_25, [
                  _createElementVNode("span", _hoisted_26, _toDisplayString(_ctx.$t('vasl-transfer.field-receiver-bank')), 1),
                  _createElementVNode("span", _hoisted_27, _toDisplayString(_ctx.$t('vasl-transfer.receiver-bank')), 1)
                ]),
                _createElementVNode("span", _hoisted_28, [
                  (_openBlock(), _createElementBlock("svg", {
                    class: "vt-flag",
                    viewBox: "0 0 28 16",
                    role: "img",
                    "aria-label": countryName.value
                  }, _cache[5] || (_cache[5] = [
                    _createElementVNode("path", {
                      fill: "#cc2028",
                      d: "M0 0h28v5H0z"
                    }, null, -1),
                    _createElementVNode("path", {
                      fill: "#fff",
                      d: "M0 5h28v6H0z"
                    }, null, -1),
                    _createElementVNode("path", {
                      fill: "#168447",
                      d: "M0 11h28v5H0z"
                    }, null, -1),
                    _createElementVNode("path", {
                      fill: "none",
                      stroke: "#d9ad20",
                      "stroke-width": ".8",
                      d: "M11 8l1 2h4l1-2-2 1-1-2-1 2z M12 11h4"
                    }, null, -1)
                  ]), 8, _hoisted_29)),
                  _createTextVNode(" " + _toDisplayString(countryName.value), 1)
                ])
              ]),
              _createElementVNode("button", {
                type: "button",
                class: "vt-btn vt-btn--secondary",
                onClick: _withModifiers(openInstruction, ["prevent"])
              }, [
                (_openBlock(), _createElementBlock("svg", _hoisted_30, [
                  _createElementVNode("path", {
                    d: icons.graduation
                  }, null, 8, _hoisted_31)
                ])),
                _createTextVNode(" " + _toDisplayString(_ctx.$t('vasl-transfer.instruction')), 1)
              ])
            ]),
            (!isDesktop.value)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  type: "button",
                  class: "vt-btn vt-btn--bank",
                  style: _normalizeStyle({background: bank.value.color}),
                  disabled: !canAct.value,
                  onClick: _withModifiers(onOpenBank, ["prevent"])
                }, [
                  _createTextVNode(_toDisplayString(_ctx.$t('vasl-transfer.open-bank', {bank: _ctx.$t(bank.value.labelKey)})) + " ", 1),
                  _createElementVNode("img", {
                    class: "vt-btn__logo",
                    src: bankLogo.value,
                    alt: ""
                  }, null, 8, _hoisted_33)
                ], 12, _hoisted_32))
              : (_openBlock(), _createElementBlock("section", _hoisted_34, [
                  _createElementVNode("p", null, _toDisplayString(_ctx.$t('vasl-transfer.qr-text')), 1),
                  _createElementVNode("div", {
                    class: "vt-qr",
                    innerHTML: qrSvg.value
                  }, null, 8, _hoisted_35)
                ])),
            _createElementVNode("section", _hoisted_36, [
              _createElementVNode("div", _hoisted_37, [
                _createElementVNode("span", null, _toDisplayString(_ctx.$t('vasl-transfer.time-left')), 1),
                _createElementVNode("span", null, _toDisplayString(timeLeft.value), 1)
              ]),
              _createElementVNode("div", _hoisted_38, [
                _createElementVNode("span", {
                  style: _normalizeStyle({width: timePercent.value + '%'})
                }, null, 4)
              ]),
              _createElementVNode("button", {
                type: "button",
                class: "vt-btn vt-btn--success",
                disabled: !canAct.value,
                onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (modal.value = 'confirm'), ["prevent"]))
              }, [
                (_openBlock(), _createElementBlock("svg", _hoisted_40, [
                  _createElementVNode("path", {
                    d: icons.doubleCheck
                  }, null, 8, _hoisted_41)
                ])),
                _createTextVNode(" " + _toDisplayString(_ctx.$t('vasl-transfer.paid')), 1)
              ], 8, _hoisted_39)
            ]),
            _createElementVNode("button", {
              type: "button",
              class: "vt-cancel",
              onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.cancelDeal(_ctx.invoice.cancelUrl)), ["prevent"]))
            }, _toDisplayString(_ctx.$t('vasl-transfer.cancel')), 1)
          ], 64))
        : (_openBlock(), _createElementBlock("section", _hoisted_42, [
            (phase.value === 'verify')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _cache[7] || (_cache[7] = _createElementVNode("div", { class: "vt-state__icon" }, [
                    _createElementVNode("span", { class: "vt-spinner" })
                  ], -1)),
                  _createElementVNode("h1", null, _toDisplayString(_ctx.$t(isDispute.value ? 'vasl-transfer.dispute-title' : 'vasl-transfer.verify-title')), 1),
                  _createElementVNode("p", null, _toDisplayString(_ctx.$t(isDispute.value ? 'vasl-transfer.dispute-text' : 'vasl-transfer.verify-text')), 1),
                  (canUploadReceipt.value)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        (!receiptUploaded.value)
                          ? (_openBlock(), _createElementBlock("label", _hoisted_43, [
                              _createElementVNode("input", {
                                type: "file",
                                accept: "image/*,application/pdf",
                                onChange: onReceiptSelected
                              }, null, 32),
                              _createTextVNode(" " + _toDisplayString(_ctx.$t('vasl-transfer.upload-receipt')), 1)
                            ]))
                          : (_openBlock(), _createElementBlock("p", _hoisted_44, _toDisplayString(_ctx.$t('vasl-transfer.receipt-uploaded')), 1))
                      ], 64))
                    : _createCommentVNode("", true)
                ], 64))
              : (isPaid.value)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createElementVNode("div", _hoisted_45, [
                      (_openBlock(), _createElementBlock("svg", _hoisted_46, [
                        _createElementVNode("path", {
                          d: icons.check
                        }, null, 8, _hoisted_47)
                      ]))
                    ]),
                    _createElementVNode("h1", null, _toDisplayString(_ctx.$t('vasl-transfer.success-title')), 1),
                    _createElementVNode("p", null, _toDisplayString(_ctx.$t('vasl-transfer.success-text')), 1)
                  ], 64))
                : (isExpired.value)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                      _createElementVNode("div", _hoisted_48, [
                        (_openBlock(), _createElementBlock("svg", _hoisted_49, [
                          _cache[8] || (_cache[8] = _createElementVNode("circle", {
                            cx: "12",
                            cy: "13",
                            r: "9"
                          }, null, -1)),
                          _createElementVNode("path", {
                            d: icons.clock
                          }, null, 8, _hoisted_50)
                        ]))
                      ]),
                      _createElementVNode("h1", null, _toDisplayString(_ctx.$t('vasl-transfer.expired-title')), 1),
                      _createElementVNode("p", null, _toDisplayString(_ctx.$t('vasl-transfer.expired-text')), 1)
                    ], 64))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                      _createElementVNode("div", _hoisted_51, [
                        (_openBlock(), _createElementBlock("svg", _hoisted_52, [
                          _createElementVNode("path", {
                            d: icons.close
                          }, null, 8, _hoisted_53)
                        ]))
                      ]),
                      _createElementVNode("h1", null, _toDisplayString(_ctx.$t('vasl-transfer.cancelled-title')), 1),
                      _createElementVNode("p", null, _toDisplayString(_ctx.$t('vasl-transfer.cancelled-text')), 1)
                    ], 64)),
            _createElementVNode("div", _hoisted_54, [
              _createElementVNode("span", _hoisted_55, [
                (_openBlock(), _createElementBlock("svg", _hoisted_56, [
                  _cache[9] || (_cache[9] = _createElementVNode("circle", {
                    cx: "12",
                    cy: "12",
                    r: "9"
                  }, null, -1)),
                  _createElementVNode("path", {
                    d: icons.info
                  }, null, 8, _hoisted_57)
                ]))
              ]),
              _createElementVNode("div", _hoisted_58, [
                _createElementVNode("span", _hoisted_59, _toDisplayString(_ctx.$t('vasl-transfer.payment-number')), 1),
                _createElementVNode("span", _hoisted_60, _toDisplayString(invoiceNumber.value), 1)
              ]),
              _createElementVNode("button", {
                type: "button",
                class: "vt-copy",
                "aria-label": _ctx.$t('vasl-transfer.copy'),
                onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_unref(copy)(null, invoiceNumber.value)), ["prevent"]))
              }, [
                (_openBlock(), _createElementBlock("svg", _hoisted_62, [
                  _createElementVNode("path", {
                    d: icons.copy
                  }, null, 8, _hoisted_63)
                ]))
              ], 8, _hoisted_61)
            ]),
            (phase.value === 'result' && returnUrl.value)
              ? (_openBlock(), _createElementBlock("a", {
                  key: 4,
                  href: returnUrl.value,
                  class: "vt-btn"
                }, _toDisplayString(_ctx.$t('vasl-transfer.return')), 9, _hoisted_64))
              : _createCommentVNode("", true)
          ]))
    ]),
    (modal.value !== null && phase.value === 'pay')
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "vt-overlay",
          onClick: _withModifiers(closeModal, ["self"])
        }, [
          _createElementVNode("div", {
            class: _normalizeClass(["vt-modal", {'vt-modal--instruction': modal.value === 'instruction'}]),
            role: "dialog",
            "aria-modal": "true"
          }, [
            _createElementVNode("button", {
              type: "button",
              class: "vt-modal__close",
              "aria-label": _ctx.$t('vasl-transfer.close'),
              onClick: _withModifiers(closeModal, ["prevent"])
            }, [
              (_openBlock(), _createElementBlock("svg", _hoisted_66, [
                _createElementVNode("path", {
                  d: icons.close
                }, null, 8, _hoisted_67)
              ]))
            ], 8, _hoisted_65),
            _createElementVNode("h2", _hoisted_68, _toDisplayString(modalTitle.value), 1),
            (modal.value === 'instruction')
              ? (_openBlock(), _createElementBlock("div", _hoisted_69, [
                  _createElementVNode("p", _hoisted_70, _toDisplayString(_ctx.$t('vasl-transfer.instruction-step', {step: instructionStep.value, total: INSTRUCTION_STEPS})), 1),
                  _createElementVNode("div", _hoisted_71, [
                    _createElementVNode("img", {
                      src: `/img/instructions_psb_vasl/psb-vasl-${instructionStep.value}.png`,
                      alt: _ctx.$t('vasl-transfer.instruction-alt', {step: instructionStep.value})
                    }, null, 8, _hoisted_72)
                  ]),
                  _createElementVNode("div", _hoisted_73, [
                    (instructionStep.value > 1)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          type: "button",
                          class: "vt-btn vt-btn--secondary",
                          onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (instructionStep.value--), ["prevent"]))
                        }, _toDisplayString(_ctx.$t('vasl-transfer.back')), 1))
                      : _createCommentVNode("", true),
                    _createElementVNode("button", {
                      type: "button",
                      class: "vt-btn",
                      onClick: _withModifiers(nextInstructionStep, ["prevent"])
                    }, _toDisplayString(instructionStep.value === INSTRUCTION_STEPS ? _ctx.$t('vasl-transfer.close') : _ctx.$t('vasl-transfer.next')), 1)
                  ])
                ]))
              : (modal.value === 'bank')
                ? (_openBlock(), _createElementBlock("div", _hoisted_74, [
                    _createElementVNode("p", _hoisted_75, _toDisplayString(_ctx.$t('vasl-transfer.bank-modal-text')), 1),
                    _createElementVNode("div", _hoisted_76, _toDisplayString(targetText.value), 1),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(rows.value, (row) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: row.key,
                        class: "vt-row"
                      }, [
                        _createElementVNode("span", _hoisted_77, [
                          (_openBlock(), _createElementBlock("svg", _hoisted_78, [
                            _createElementVNode("path", {
                              d: icons[row.icon]
                            }, null, 8, _hoisted_79)
                          ]))
                        ]),
                        _createElementVNode("div", _hoisted_80, [
                          _createElementVNode("span", _hoisted_81, _toDisplayString(row.label), 1),
                          _createElementVNode("span", _hoisted_82, _toDisplayString(row.value), 1)
                        ]),
                        (row.copy)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 0,
                              type: "button",
                              class: "vt-copy",
                              "aria-label": _ctx.$t('vasl-transfer.copy'),
                              onClick: _withModifiers(($event: any) => (_unref(copy)(null, row.copy)), ["prevent"])
                            }, [
                              (_openBlock(), _createElementBlock("svg", _hoisted_84, [
                                _createElementVNode("path", {
                                  d: icons.copy
                                }, null, 8, _hoisted_85)
                              ]))
                            ], 8, _hoisted_83))
                          : _createCommentVNode("", true)
                      ]))
                    }), 128)),
                    _createElementVNode("button", {
                      type: "button",
                      class: "vt-btn vt-btn--bank",
                      style: _normalizeStyle({background: bank.value.color}),
                      onClick: _withModifiers(openBank, ["prevent"])
                    }, _toDisplayString(_ctx.$t('vasl-transfer.open-bank', {bank: _ctx.$t(bank.value.labelKey)})), 5),
                    (bankSecondsLeft.value !== null)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_86, _toDisplayString(_ctx.$t('vasl-transfer.auto-open', {seconds: bankSecondsLeft.value})), 1))
                      : _createCommentVNode("", true),
                    (bankError.value)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_87, _toDisplayString(bankError.value), 1))
                      : _createCommentVNode("", true)
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_88, [
                    _createElementVNode("div", _hoisted_89, [
                      (_openBlock(), _createElementBlock("svg", _hoisted_90, [
                        _createElementVNode("path", {
                          d: icons.warning
                        }, null, 8, _hoisted_91)
                      ])),
                      _createElementVNode("span", null, _toDisplayString(_ctx.$t('vasl-transfer.confirm-warning')), 1)
                    ]),
                    _createElementVNode("p", _hoisted_92, _toDisplayString(_ctx.$t('vasl-transfer.confirm-text')), 1),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(confirmRows.value, (row) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: row.key,
                        class: "vt-row"
                      }, [
                        _createElementVNode("span", _hoisted_93, [
                          (_openBlock(), _createElementBlock("svg", _hoisted_94, [
                            _createElementVNode("path", {
                              d: icons[row.icon]
                            }, null, 8, _hoisted_95)
                          ]))
                        ]),
                        _createElementVNode("div", _hoisted_96, [
                          _createElementVNode("span", _hoisted_97, _toDisplayString(row.label), 1),
                          _createElementVNode("span", _hoisted_98, _toDisplayString(row.value), 1)
                        ])
                      ]))
                    }), 128)),
                    (_ctx.invoice.isTrxIdRequiredForConfirm)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_99, [
                          _createElementVNode("label", _hoisted_100, _toDisplayString(_ctx.$t('invoice.transaction-id-label')), 1),
                          _createElementVNode("input", {
                            id: "vt-trx-input",
                            class: _normalizeClass(["vt-input", {'is-error': _ctx.transactionIdError}]),
                            type: "text",
                            value: _ctx.transactionId,
                            placeholder: _ctx.$t('invoice.transaction-id-placeholder'),
                            onInput: onTransactionIdInput
                          }, null, 42, _hoisted_101),
                          (_ctx.transactionIdError)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_102, _toDisplayString(_ctx.transactionIdError), 1))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("button", {
                      type: "button",
                      class: "vt-btn vt-btn--success",
                      disabled: !canAct.value,
                      onClick: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.confirmTransfer && _ctx.confirmTransfer(...args)), ["prevent"]))
                    }, _toDisplayString(_ctx.$t('vasl-transfer.confirm')), 9, _hoisted_103),
                    _createElementVNode("button", {
                      type: "button",
                      class: "vt-btn vt-btn--secondary",
                      onClick: _withModifiers(closeModal, ["prevent"])
                    }, _toDisplayString(_ctx.$t('vasl-transfer.back-to-payment')), 1)
                  ]))
          ], 2)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass(["vt-toast", {'is-visible': !!_unref(copyState).copyHintTimeout}])
    }, _toDisplayString(_ctx.$t('vasl-transfer.copied')), 3)
  ]))
}
}

})